import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function FlashcardPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="flashcard" />

    </>
  );
}

export default FlashcardPhysTopics;